import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import {requestCreateNews, resetCreateNewsData} from '../store/news/actions/create-news-actions';
import { toast } from 'react-toastify';

const newsInitialState = {
    heading: '',
    heading_eng: '',
    text: '',
    text_eng: '',
    url: '',
    mainImage: null,
    company: 'DEFAULT',
};

const NewsCreateForm = ({ onSuccess }) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const [data, setData] = useState(newsInitialState);
    const { response, error } = useSelector(state => state.createNewsData);

    const handleChange = (e) => {
        const { name, value, files } = e.target;
        if (files) {
            setData({ ...data, [name]: files[0] });
        } else {
            setData({ ...data, [name]: value });
        }
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        const formData = new FormData();
        formData.append('heading', data.heading);
        formData.append('text', data.text);
        formData.append('headingEng', data.heading_eng);
        formData.append('textEng', data.text_eng);
        formData.append('url', data.url || '');
        if (data.mainImage) formData.append('mainImage', data.mainImage);
        formData.append('company', 'DEFAULT');

        dispatch(requestCreateNews(formData));
    };

    useEffect(() => {
        if (response) {
            toast.success(t('news.createNews') + ' ' + t('common.success'));
            setData(newsInitialState);
            onSuccess?.();
        } else if (error) {
            toast.error(t('news.createNews') + ' ' + t('common.error'));
        }
    }, [response, error, onSuccess]);

    return (
        <form onSubmit={handleSubmit} className="space-y-4">
            <h2 className="text-lg font-semibold text-gray-800 mb-2">{t('news.createNews')}</h2>

            <input type="text" name="heading" value={data.heading} onChange={handleChange} placeholder={t('news.newsTitle')} className="w-full p-2 border rounded text-sm" />
            <input type="text" name="heading_eng" value={data.heading_eng} onChange={handleChange} placeholder={`${t('news.newsTitle')} (EN)`} className="w-full p-2 border rounded text-sm" />
            <textarea name="text" value={data.text} onChange={handleChange} placeholder={t('news.content')} className="w-full p-2 border rounded text-sm h-24 resize-y" />
            <textarea name="text_eng" value={data.text_eng} onChange={handleChange} placeholder={`${t('news.content')} (EN)`} className="w-full p-2 border rounded text-sm h-24 resize-y" />
            <input type="text" name="url" value={data.url} onChange={handleChange} placeholder="URL" className="w-full p-2 border rounded text-sm" />
            <input type="file" name="mainImage" onChange={handleChange} className="w-full text-sm border border-gray-300 rounded p-1 bg-white" />
            <button type="submit" className="w-full bg-[#34495e] hover:bg-[#16324d] text-white py-2 rounded text-sm font-medium">{t('common.submit')}</button>
        </form>
    );
};

export default NewsCreateForm;
